import { AnimationConfig } from "@dineout-payment-success-ui/helpers/index";

export const LOTTIE_ANIMATIONS = {
    CONGRATS_LOTTIE: "portal/m/dineout/dineout_congrats.json",
    SMILEY_LOTTIE: "portal/m/dineout/emoji-glass.json",
    TABLE_RESERVATION_CELEBRATION: "portal/static-assets/lotties/dineout/Final_Fathers_Day_camp1.json",
    TABLE_RESERVATION_CELEBRATION_SOUND: "portal/static-assets/audio/Faaaa_Sound_Fathers_Day.mp3",
};

export const SPLIT_BILL_LOTTIE_URL = "portal/static-assets/lotties/scan_bill.json";

export const ONE_WHITE_CLOUDINARY_URL = "portal/m/dineout/one_white.webp";

export const LOTTIE_ANIMATIONS_CONGRATS_PROPS = AnimationConfig(false);

export const TABLE_RESERVATION_CELEBRATION_SOUND_TRIGGER_FRAME = 13;

export const TABLE_RESERVATION_CELEBRATION_LOTTIE_PROPS = {
    ...AnimationConfig(false),
    loop: false,
    autoplay: true,
    playIfVisible: false,
};

export const LOTTIE_ANIMATIONS_SMILEY_PROPS = AnimationConfig(true);

export const SPLIT_BILL_LOTTIE_PROPS = AnimationConfig(true);

export const SPLIT_BILL_WIDGET_LOTTIE_PROPS = AnimationConfig(true);
